// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__30TeK","rootSmall":"AddTileButton_rootSmall__1QHEa"};